import {
  selectNotification,
  selectNotificationStatus,
} from './model/notification.selectors';
import {
  notificationsMarkAsRead,
  registerPushSubscription,
} from './model/notification.thunks';
import {
  addNotification,
  changeHasUnreadTo,
  changeNotificationIsOpenTo,
  clearNotification,
} from './model/notificationSlice';

export const notificationModel = {
  selectors: { selectNotification, selectNotificationStatus },
  actions: {
    changeHasUnreadTo,
    addNotification,
    changeNotificationIsOpenTo,
    clearNotification,
  },
  thunks: {
    notificationsMarkAsRead,
    registerPushSubscription,
  },
};
